import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Spinner } from './Spinner'

interface ScreenLoadingFallbackProps {
  children?: ReactNode
  spinnerColor?: string
  surface?: 'primary' | 'transparent'
}

export function ScreenLoadingFallback({
  children,
  spinnerColor,
  surface = 'primary',
}: ScreenLoadingFallbackProps) {
  if (surface === 'transparent') {
    return (
      <View className="flex-1 justify-center items-center px-6">
        <Spinner size="large" color={spinnerColor} />
        {children}
      </View>
    )
  }

  return (
    <View className="flex-1 justify-center items-center bg-background-primary px-6">
      <Spinner size="large" color={spinnerColor} />
      {children}
    </View>
  )
}
